import { fromEvent } from 'rxjs'

export const clickObservable$ = fromEvent(window, 'click')

export const resizeObservable$ = fromEvent(window, 'resize')

export const scrollObservable$ = fromEvent(window, 'scroll')
